import { styled, TableRow, tableRowClasses } from '@mui/material';

export default styled(TableRow)(({ theme }) => ({
  [`&.${tableRowClasses.head}`]: {
    th: {
      borderBottom: `2px solid ${theme.palette.primary.main}`
    }
  }
}));
